// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mailingListStyles } from "@ces/App/Widgets/Footer/MailingList";
import { color, xScreen } from "@ces/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

mailingListStyles.container = {
    css: css`
        display: flex;
        width: 90%;
        height: 100%;
        justify-content: center;
        align-items: center;
        gap: 24px 20px;
        flex-wrap: wrap;
        ${xScreen("lte", "md")} {
            width: 100%;
            flex-direction: column;
        }
    `,
};

mailingListStyles.descriptionText = {
    variant: "h5",
    as: "p",
    css: css`
        margin-bottom: 0;
        ${xScreen("lte", "md")} {
            text-align: center;
        }
    `,
};

mailingListStyles.button = {
    mergeCss: true,
    variant: "secondary",
    buttonType: "solid",
    sizeVariant: "large",
    css: css`
        padding: 0 28px;
    `,
};

mailingListStyles.clickable = {
    css: css`
        &:hover {
            color: ${color("text.main")};
        }
    `,
};